export default {
  // tickets
  CodeAssotiation: 1000,
  RegisterNewTicket: 1001,
  CallTicket: 1002,
  CallAgainTicket: 1003,
  RedirectTicket: 1004,
  BackToAliveTicket: 1005,
  CloseTicket: 1006,
  PostponeTicket: 1007,
  CancelTicket: 1008,
  AppointTicket: 1009,
  ReadiedTicket: 1010,

  // other
  SoundCheck: 2000,
  OperatorLogin: 2001,
  OperatorLogout: 2002,
  ChangeOpWorkspaceStatus: 2003,
  ReloadDevice: 2004,
  DissociateDevice: 2005,
  EnableDevice: 2006,
  DisableDevice: 2007
}
